import { Component, ElementRef, OnInit } from '@angular/core';
import * as MagnoliaConfigActions from '../../../../../store/actions/magnolia-config.actions';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getOptionDetails,
  getProductDetailsPending,
} from '../../../../../store/reducers';
import { OnDestroyHookDirective } from '../../../../../shared/hooks';
import { Router } from '@angular/router';
import { Product } from '@dch/products-business-logic';
import { ProductUsageService2 } from '@dch/ng-usage';
import { CustomerService, InceptionService } from '@proximus/ng-common';
import { ProductDetailsState } from '../../../../../store/reducers/product-details.reducer';
import { GetOptionDetails } from '../../../../../store/actions/product-details.actions';
import { combineLatest } from 'rxjs';

const FLEX_EMERGENCY_MPCUUID = 'MEGMK';

@Component({
  selector: 'mprd-flex-emergency-manage-pxsplus',
  templateUrl: './flex-emergency-manage-pxsplus.component.html',
})
export class FlexEmergencyManagePxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  public isPending: boolean;
  isOnlyOneNumber = false;
  eligibleFlexEmergencyProducts: Array<Product> = [];
  oneAlreadyActive = false;
  selectedProduct: any;
  globalId: number;

  constructor(
    private store: Store<ApplicationState | ProductDetailsState>,
    private productUsageService: ProductUsageService2,
    private customerService: CustomerService,
    private router: Router,
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.customerService
        .getCustomerAccount()
        .subscribe((customerAccount: any) => {
          this.globalId = customerAccount?.customerAccountResponse?.globalId;
          this.getProducts();
        }),
    );

    this.addSubscription(
      combineLatest([
        this.store.select(getOptionDetails),
        this.store.select(getProductDetailsPending),
      ]).subscribe((data) => {
        const mobileProductList = data[0]?.mobileProductList;
        this.isPending = data[1];
        if (
          mobileProductList &&
          mobileProductList.length > 0 &&
          !this.isPending
        ) {
          //we get the eligible products
          this.eligibleFlexEmergencyProducts = mobileProductList;

          if (this.eligibleFlexEmergencyProducts.length < 1) {
            this.routeToOverview();
          }
          this.checkForOneActive();
          this.isOnlyOneNumber =
            this.eligibleFlexEmergencyProducts.length === 1;
        } else {
          this.eligibleFlexEmergencyProducts = [];
          this.isOnlyOneNumber = false;
        }
        setTimeout(() => {
          this.inceptionService.panelAccordion(this.elementRef);
          this.inceptionService.init();
        });
      }),
    );
  }

  private getProducts() {
    this.store.dispatch(
      new GetOptionDetails({
        optionId: FLEX_EMERGENCY_MPCUUID,
        customerId: this.globalId,
      }),
    );
    this.store.dispatch(new MagnoliaConfigActions.GetOptionGroupsConfig());
  }

  private routeToOverview() {
    this.router.navigate(['/overview']);
  }

  routeToStep1(): void {
    this.router.navigate(['/pxsplus/flex-emergency-entry']);
  }

  private checkForOneActive() {
    this.eligibleFlexEmergencyProducts.forEach((product: any) => {
      const productUsage$ = this.productUsageService.getSelectedProductUsage(
        product,
        'productDetails',
      );
      productUsage$.subscribe((productUsage) => {
        const reportingCategoryGroup =
          productUsage.reportingCategoryGroups.find(
            (item) => item.code === 'data',
          );
        const reportingCategories =
          reportingCategoryGroup.reportingCategories.find(
            (item) => item.code === 'data.extra.osb',
          );
        if (
          reportingCategories?.instances &&
          reportingCategories?.instances.some((instance) => {
            // @ts-ignore
            return (
              instance &&
              instance.relatedMpcUuid?.toUpperCase() === FLEX_EMERGENCY_MPCUUID
            );
          })
        ) {
          this.oneAlreadyActive = true;
        }
      });
    });
  }
}
